import { RootState } from "appRedux/store"
import { updateUserProfile, userProfileDefaultValue } from "appRedux/slices/userSlice"
import { updateInitSlice } from "appRedux/slices/initSlice"
import { updateItemFormFields } from "appRedux/slices/itemFormSlice"

export async function handleOnInitQueryStarted(arg: any, { dispatch, queryFulfilled, getState }: any) {
  try {
    const { data } = await queryFulfilled

    if (!data) return
    const state = getState() as RootState
    const userProfile = state.user.profile || userProfileDefaultValue as Profile
    const itemFormFields = state.itemForm.formFields

    const { userInfo, ...rest } = data

    dispatch(updateInitSlice(data))

    if (rest?.supportedCurrencies?.defaultCurrency) {
      dispatch(updateItemFormFields({
        ...itemFormFields,
        currency: rest.supportedCurrencies.defaultCurrency
      }))
    }

    dispatch(updateUserProfile({
      ...userProfile,
      isPremium: userInfo?.isPremium
    }))
  } catch (error) {
    console.error("Error fetching init api:", error)
  }
}
